/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
// Package Imports
import { Directive, ElementRef, Input } from '@angular/core';

// Custom Types
enum Parity { Even = 'datatable-row-even', Odd = 'datatable-row-odd'}
enum Color { EvenColor = '#ffffff', OddColor = '#f9f9f9'}

@Directive({
  selector: '[appTableRowDetail]'
})
export class TableRowDetailDirective {
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('tableRowDetail')
  set rowDetailContext(value: any) {
    this.applyRowStyles();
  }

  constructor(private readonly element: ElementRef) { }

  // TODO: This workaround with styles should be removed when the following story will be completed for ngx-datatable:
  // https://github.com/swimlane/ngx-datatable/issues/992
  // Then we could use value.rowIndex from template to define even/odd rows in details control.
  private applyRowStyles(): void {
    const templateRoot = this.getTemplateRoot(this.element.nativeElement);

    if (templateRoot) {
      const rowClasses = templateRoot.parentElement &&
                          templateRoot.parentElement.firstElementChild &&
                          templateRoot.parentElement.firstElementChild.classList;
      const templateRootClasses = templateRoot.classList;

      if (rowClasses && templateRootClasses) {
        if (rowClasses.contains(Parity.Odd)) {
          if (!templateRootClasses.contains(Parity.Odd)) {
            templateRoot.style.backgroundColor = Color.OddColor;
          }
        }
        else if (rowClasses.contains(Parity.Even)) {
          if (!templateRootClasses.contains(Parity.Even)) {
            templateRoot.style.backgroundColor = Color.EvenColor;
          }
        }
      }
    }
  }

  private getTemplateRoot(element: any): any {
    if (!!element) {
      return element.classList &&
             element.classList.contains('datatable-row-detail') ? element : this.getTemplateRoot(element.parentElement);
    }

    return null;
  }
}
